import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'
import { useProjectStore } from '@/stores/project';
import { useIdentityStore } from '@/stores/identity';

export async function buildParallelRun() {
  


  const identity = useIdentityStore();
  const project = useProjectStore();

    //Only show the card to admins as this is an internal task
    if(identity.type !== 'Administrator') return null;

    var milestones = project.milestones;    

    // Check if the trigger milestone (Migration) is completed before showing the Parallel Run card
    const triggerMilestone = milestones.find(m => m.type === 'Migration');
    if(triggerMilestone == null || triggerMilestone.status !== 'SuccessfullyCompleted') {
      return null;
    }

    const milestone = milestones.find(m => m.type === 'ParallelRun');
    if(milestone == null) {
      return null;
    }

    const card = {
    id: milestone.milestoneId,
    title: 'Parallel Run',
    subtitle: 'Execute a parallel run to validate the new system against the existing one.',
    progress: 0,
    subProgressMessage: formatDateToWrittenDate(milestone.scheduledCompletion),
    status: milestone.status,
    route: '/tasks/internal-milestone/' + milestone.milestoneId, 
    createdDate: new Date(milestone.scheduledCompletion)
  }
  return card 
}

